import { nodeApi } from '$lib/settings'
import { createQuery } from '@tanstack/svelte-query'

async function getAffiliateRegistrationCustomizationSettings() {
	const response =
		await nodeApi.settingsV1TenantSettingsService.tenantSettingsServiceGetAffiliateRegistrationCustomization()
	return response.data.customization
}

export const affiliateRegistrationCustomizationQueryKey = ['affiliateRegistrationCustomization']

export function useAffiliateRegistrationCustomizationQuery() {
	return createQuery({
		queryKey: affiliateRegistrationCustomizationQueryKey,
		queryFn: getAffiliateRegistrationCustomizationSettings,
	})
}
